import DynamicSearch from './DynamicSearch';

export default DynamicSearch;
